(function () {
    'use strict';

    angular
        .module('core.services')
        .service('ApplicationSharedDataService', ApplicationSharedDataService)

    /** @ngInject */
    function ApplicationSharedDataService(HttpService) {
        const ApplicationSharedDataService = {
            getByParameters,
            post,
            updateMultiple,
            put,
            deleteData
        }

        return ApplicationSharedDataService;

        function getByParameters(params) {
            return HttpService.get('/applications/shared-data/by-parameters', {
                params
            });
        }

        function post(applicationSharedData) {
            return HttpService.post('/applications/shared-data', applicationSharedData);
        }

        function updateMultiple(applicationSharedDataList) {
            return HttpService.post('/applications/shared-data//update-multiple', applicationSharedDataList);
        }

        function put(applicationSharedData) {
            return HttpService.put('/applications/shared-data', applicationSharedData);
        }

        function deleteData(applicationSharedDataId) {
            return HttpService.delete(`/applications/shared-data/${applicationSharedDataId}`);
        }
    }
}());